import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {User} from "src/app/modules/auth/models/User";
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import {Subscription} from "rxjs";
import {NgClass} from "@angular/common";
import {
  DESKTOP_PRIMARY_NAV_ITEMS,
  DESKTOP_SECONDARY_NAV_ITEMS,
  LISTS_ACTIVE_PREFIXES,
} from "../navigation/navigation-items.constants";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, TranslateModule, NgClass],
})
export class NavbarComponent implements OnDestroy {
  @Input() user?: User;
  public readonly primaryNavigationItems = DESKTOP_PRIMARY_NAV_ITEMS;
  public readonly secondaryNavigationItems = DESKTOP_SECONDARY_NAV_ITEMS;
  public currentYear: number = new Date().getFullYear();
  private readonly listsActivePrefixes = LISTS_ACTIVE_PREFIXES;
  private readonly subscriptions: Subscription[] = [];

  get isListsRoute(): boolean {
    return this.listsActivePrefixes.some(
      (prefix) =>
        this.router.url === prefix || this.router.url.startsWith(prefix + "/")
    );
  }

  constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
    const routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.cdr.markForCheck();
      }
    });
    this.subscriptions.push(routeSubscription);
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
